import React from 'react';

const Company = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-pink-600 to-pink-700 text-white py-20">
        <div className="container mx-auto px-4">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold mb-6">About LEMASX</h1>
            <p className="text-xl text-pink-100">
              LEMASX Technology Co., Ltd - Bridging Japan and Vietnam through engineering excellence.
            </p>
          </div>
        </div>
      </section>

      {/* Director's Message Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-3 gap-8 items-start max-w-6xl">
            {/* Director Photo */}
            <div className="md:col-span-1">
              <div className="bg-pink-50 rounded-2xl p-6 text-center">
                <div className="bg-gray-200 border-2 border-dashed rounded-full w-48 h-48 mx-auto mb-4" />
                <h3 className="text-xl font-bold text-gray-900">Le Thai Minh</h3>
                <p className="text-gray-600">Founder & CEO</p>
                <p className="text-sm text-gray-500 mt-1">Born: 1988</p>
              </div>
            </div>

            {/* Message */}
            <div className="md:col-span-2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 border-b-4 border-pink-600 inline-block pb-2">Profile</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  <strong>June 2011:</strong> Graduated from University of Transportation Technology, Mechanical Engineering Department.
                </p>
                <p>
                  <strong>July 2011:</strong> Worked at Denso Vietnam and Denso HQ. Responsible for designing engine intake/exhaust systems (throttle, actuators, EGR valves, etc.). In product development, performed detailed design, 3D modeling, CAE analysis (thermal, vibration, CFD), prototype drawings, and testing evaluation. Gained experience up to mass production.
                </p>
                <p>
                  <strong>Oct 2018 - Present:</strong> Aerial work platform design projects. Acquipink knowledge in sheet metal parts. Mainly designs using top-down method in Creo.
                </p>
                <p>
                  <strong>2022:</strong> Had the idea of starting own business and formed a mechanical design team. Took on jig design, sheet metal, plastic, conveyor, and automatic machine design projects.
                </p>
                <p>
                  <strong>2023:</strong> Added precision machining projects from Japanese clients. Directly handled design to machining, ensuring high quality.
                </p>
                <p>
                  <strong>2024 May:</strong> Established LEMASX Technology Co., Ltd (5+ members). Continue design and Vietnam procurement projects.
                </p>
                <p className="pt-4 text-pink-600 font-medium border-l-4 border-pink-600 pl-4">
                  Our goal is to bridge Japan and Vietnam through technology, building Win-Win relationships with partners and customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Skills Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 border-b-4 border-pink-600 inline-block pb-2">Expertise & Skills</h2>
          <div className="grid md:grid-cols-3 gap-12">
            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center text-pink-600 font-bold text-lg">C</span>
                CAD Software Experience
              </h3>
              <div className="space-y-5">
                {[
                  { name: 'NX', years: 10 },
                  { name: 'Creo', years: 6 },
                  { name: 'SolidWorks', years: 5 },
                  { name: 'AutoCAD', years: 3 },
                  { name: 'Catia V5', years: 2 },
                  { name: 'Inventor', years: 2 },
                  { name: 'I-cad SX', years: 1 },
                ].map((skill, index) => (
                  <div key={index} className="group">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-800 font-medium">{skill.name}</span>
                      <span className="text-pink-600 font-bold text-sm">{skill.years * 10}%</span>
                    </div>
                    <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-gradient-to-r from-pink-400 to-pink-600 rounded-full transition-all duration-500 group-hover:from-pink-500 group-hover:to-pink-700"
                        style={{ width: `${skill.years * 10}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center text-pink-600 font-bold text-lg">A</span>
                CAE Software Experience
              </h3>
              <div className="space-y-5">
                {[
                  { name: 'ANSYS', years: 10 },
                  { name: 'STAR-CCM+', years: 8 },
                  { name: 'LS-Dyna', years: 2 },
                ].map((skill, index) => (
                  <div key={index} className="group">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-800 font-medium">{skill.name}</span>
                      <span className="text-pink-600 font-bold text-sm">{skill.years * 10}%</span>
                    </div>
                    <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-gradient-to-r from-pink-400 to-pink-600 rounded-full transition-all duration-500 group-hover:from-pink-500 group-hover:to-pink-700"
                        style={{ width: `${skill.years * 10}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg border border-gray-100">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                <span className="w-10 h-10 bg-pink-100 rounded-lg flex items-center justify-center text-pink-600 font-bold text-lg">&lt;/&gt;</span>
                Programming & Tools
              </h3>
              <div className="space-y-5">
                {[
                  { name: 'Python', years: 7 },
                  { name: 'JavaScript', years: 6 },
                  { name: 'React/Next.js', years: 5 },
                  { name: 'C# / .NET', years: 4 },
                  { name: 'Node.js', years: 4 },
                  { name: 'SQL / Database', years: 5 },
                  { name: 'Git / DevOps', years: 6 },
                ].map((skill, index) => (
                  <div key={index} className="group">
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-800 font-medium">{skill.name}</span>
                      <span className="text-pink-600 font-bold text-sm">{skill.years * 10}%</span>
                    </div>
                    <div className="w-full h-3 bg-gray-100 rounded-full overflow-hidden">
                      <div 
                        className="h-full bg-gradient-to-r from-pink-400 to-pink-600 rounded-full transition-all duration-500 group-hover:from-pink-500 group-hover:to-pink-700"
                        style={{ width: `${skill.years * 10}%` }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl">
            <div className="mb-12">
              <h2 className="text-4xl font-bold text-gray-900 mb-4 border-b-4 border-pink-600 inline-block pb-2">Vision & Core Values</h2>
            </div>

            {/* Vision */}
            <div className="bg-gradient-to-r from-pink-600 to-pink-700 text-white rounded-2xl p-8 mb-8 relative">
              <div className="absolute top-6 right-6">
                <svg className="w-12 h-12 text-white opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold mb-4">Our Vision</h3>
              <p className="text-pink-50 leading-relaxed text-lg">
                To become one of the top companies in applying AI and integrated technology to mechanical engineering. We aim to build an automated design ecosystem that helps customers save time and enhance creativity.
              </p>
            </div>

            {/* Core Values */}
            <div className="bg-gray-50 rounded-2xl p-8 relative">
              <div className="absolute top-6 right-6">
                <svg className="w-12 h-12 text-pink-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Core Values</h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <span className="text-pink-600 font-bold text-lg">Creativity</span>
                  <span className="text-gray-700">Always pursue innovation and maintain a learning mindset.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-pink-600 font-bold text-lg">Quality</span>
                  <span className="text-gray-700">We promise to deliver products of the highest standards.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="text-pink-600 font-bold text-lg">Customer Focus</span>
                  <span className="text-gray-700">Always listen to customer needs and provide optimal solutions.</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Company;